'use strict';

const util = {
    isMobile: require('./modules/util/isMobile')
};

let observer = null;
let hasExecuted = false;

function executeUsableNetToggleLogic() {
    if (hasExecuted) return;

    if (observer) {
        observer.disconnect();
        observer = null;
    }

    setTimeout(() => {
        const usableNetToggle = document.querySelector('#usntA40Toggle a');
        const oneTrustButtonGroup = document.querySelector('#onetrust-button-group-parent');

        if (oneTrustButtonGroup) {
            oneTrustButtonGroup.style.paddingBottom = '55px';
        }

        if (usableNetToggle) {
            const parent = usableNetToggle.parentElement;
            if (parent) {
                parent.setAttribute('tabindex', '0');
                usableNetToggle.focus();

                usableNetToggle.addEventListener('blur', function () {
                    setTimeout(() => {
                        const skipToContent = document.querySelector('.js-skip-to-content');
                        if (skipToContent) {
                            skipToContent.focus();
                        }
                    }, 200);
                });
            }
            hasExecuted = true;
        }
    }, 1000);
}

function init() {
    // check if OneTrust banner already exists
    const existingBanner = document.getElementById('onetrust-banner-sdk');
    if (existingBanner) {
        executeUsableNetToggleLogic();
        return;
    }

    // create mutation observer to watch for OneTrust banner
    observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    const element = node;
                    if (element.id === 'onetrust-banner-sdk') {
                        executeUsableNetToggleLogic();
                    }
                }
            });
        });
    });

    // start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function cleanup() {
    if (observer) {
        observer.disconnect();
        observer = null;
    }
}

module.exports = {
    init: init,
    cleanup: cleanup,
    executeUsableNetToggleLogic: executeUsableNetToggleLogic
};
